<template>
    <div id="ticket-form" class="container" v-bind:class="{ 'wrapper': current_step <= 2 }">
        <input type="hidden" name="eccId" v-model="ticket.eccId" />
        <h2 v-if="current_step == 0">{{ $t('wizard.registra_garanzia') }}</h2>
        <h2 v-else-if="current_step == 1">{{ $t('wizard.registra_garanzia_descrizione') }}</h2>


        <h3 v-if="current_step == 0">{{ $t('wizard.registra_garanzia_descrizione') }}</h3>
        <h3 v-else-if="current_step == 1">{{ $t('step2_garanzia.subtitle') }}</h3>


        <div class="wizard">
            <div class="wizard-header  wizard-header-2" v-if="current_step <= 1">
                <div @click="if (this.current_step > 0) this.current_step = 0; this.postMessageIframe();"
                    v-bind:class="{ active: current_step === 0, done: current_step > 0 }">
                    <span>1</span>
                    <div class="hr"></div>
                </div>
                <div @click="if (this.current_step > 1) this.current_step = 1; this.postMessageIframe();"
                    v-bind:class="{ active: current_step === 1, done: current_step > 1 }">
                    <span>2</span>
                    <div class="hr"></div>
                </div>
            </div>

            <div class="row gx-0 justify-content-center" v-bind:class="{ 'wizard-form': current_step <= 1 }">

                <div class="row gx-0" v-if="current_step == 0">

                    <div class="col-12">
                        <div class="wrapper-fields">
                            <div class="wrapper-input select" v-bind:class="{ error: errors.family }">
                                <select required v-model="ticket.family"
                                    @change="onClearError({ key: 'family', value: !!$event.target.value })">
                                    <option disabled selected value="" hidden>{{ $t('step2.select_family') }} <span
                                            class="ic-require">*</span></option>
                                    <option v-for="item in families" :key="item.value" v-bind:value="item.value"
                                        v-text="$t(item.label)">
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="wrapper-fields">
                            <div class="wrapper-input select" v-bind:class="{ error: errors.product }">
                                <select required v-model="ticket.product"
                                    @change="onClearError({ key: 'product', value: !!$event.target.value })">
                                    <option disabled selected value="" hidden>{{ $t('step2.select_product') }} <span
                                            class="ic-require">*</span></option>
                                    <option v-for="item in getProductsForFamily()" :key="item.value"
                                        v-bind:value="item.value" v-text="$t(item.label)">
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="col-12" v-if="hasChooseADoor()">
                        <div class="wrapper-fields">
                            <div class="wrapper-input select" v-bind:class="{ error: errors.product_with_door }">
                                <select required v-model="ticket.product_with_door"
                                    @change="onClearError({ key: 'product_with_door', value: !!$event.target.value })">
                                    <option disabled selected value="" hidden>{{ $t('step2.select_product_with_door') }}
                                        <span class="ic-require">*</span>
                                    </option>
                                    <option v-for="item in getProductsInAdditionToDoor()" :key="item.value"
                                        v-bind:value="item.value" v-text="$t(item.label)">
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="wrapper-fields">
                            <div class="serial-number-row d-flex flex-lg-row flex-column">
                                <div class="col-12 col-lg-8 wrapper-input"
                                    v-bind:class="{ error: errors.num_matricola }">
                                    <input type="text" v-model="ticket.num_matricola"
                                        :placeholder="$t('step2.num_matricola') + '*'"
                                        @input="onClearError({ key: 'num_matricola', value: !!$event.target.value })" />
                                </div>
                                <div class="col-0 col-lg-1"></div>
                                <div v-if="getImgProduct() != null" class="serial-number-tooltip col-12 col-lg-3 mt-lg-0 mt-2">
                                    <button type="button" :disabled="!ticket.product"
                                        class="btn-tooltip btn-outline-primary text-uppercase" data-bs-toggle="modal"
                                        data-bs-target="#staticBackdrop">
                                        {{ $t('step2.num_matricola_dove_si_trova') + " ?" }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="wrapper-fields">
                            <div class="wrapper-input date" v-bind:class="{ error: errors.data_acquisto_prodotto }">
                                <datepicker v-model="this.ticket.data_acquisto_prodotto" :locale="this.getLocaleFns()"
                                    :placeholder="$t('step2.data_inizio_utilizzo') + '*'" inputFormat="dd/MM/yyyy"
                                    @update:modelValue="onClearError({ key: 'data_acquisto_prodotto', value: !!$event })" />
                            </div>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="wrapper-fields">
                            <div class="wrapper-input-file" v-bind:class="{ error: errors.proof_of_purchase }">
                                <p>{{ $t('step2_garanzia.proof_of_purchase') }} *</p>
                                <div class="file-upload-row d-flex align-items-center">
                                    <label for="proof-of-purchase-upload" class="custom-file-upload">
                                        <span v-if="!fileUploading">{{ $t('step2.scegli_file') }}</span>
                                        <div v-else class="loader"></div>
                                    </label>
                                    <input ref="proofOfPurchaseUpload" id="proof-of-purchase-upload" type="file" @change="previewProofOfPurchaseFile"
                                        accept="image/*,.pdf,.heic" />
                                    <div v-if="proofOfPurchaseFileName" class="file-uploaded d-flex align-items-center">
                                        <span class="file-uploaded-name d-block">{{ getTruncatedFileName(proofOfPurchaseFileName) }}</span>
                                        <button class="mx-2 border-0 bg-transparent p-0" @click="removeProofOfPurchase"><img
                                                style="width: 20px;height: 20px;" :src="getRemoveFileIcon()" /></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal fade" id="staticBackdrop" tabindex="-1" aria-labelledby="staticBackdropLabel"
                        aria-hidden="true">
                        <div class="modal-dialog modal-dialog-centered">
                            <div class="modal-content">
                                <button class="icon-close" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
                                    <img v-bind:src="iconCloseModal">
                                </button>
                                <div class="modal-body">
                                    <div v-if="getImgProduct() != null">
                                        <p class="title-product">
                                            {{ $t('step2.modal_title') }}
                                        </p>
                                        <div class="separator"></div>
                                        <p class="subtitle-product">
                                            {{ $t('step2.modal_subtitle') }}
                                        </p>
                                        <img v-bind:src="getImgProduct()" class="img-product">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>


                <div class="row gx-0" v-if="current_step == 1">

                    <div class="wrapper-fields">
                        <div class="row gx-0 row-type-customer">
                            <div class="col-12">
                                <div class="wrapper-input select" v-bind:class="{ error: errors.tipo_di_cliente }">
                                    <select required v-model="ticket.tipo_di_cliente"
                                        @change="onClearError({ key: 'tipo_di_cliente', value: !!$event.target.value })">
                                        <option disabled selected value="" hidden>{{ $t('step2_garanzia.select_tipo_di_cliente') }} <span
                                                class="ic-require">*</span></option>
                                        <option v-for="item in customer_type_choices" :key="item.id" v-bind:value="item.id">
                                            {{ item.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="wrapper-fields">
                        <customer-form v-model="ticket.customer" :companyRequired="false" :companyVisible="true"
                            :errors="errors" @onClearError="onClearError" />
                    </div>

                    <div class="wrapper-fields">
                        <div class="col-12" style="margin-top:60px;">
                            <div class="wrapper-input-checkbox" v-bind:class="{ error: errors.privacy }">
                                <input type="checkbox" id="privacy" v-bind:checked="ticket.privacy"
                                    v-model="ticket.privacy"
                                    @change="onClearError({ key: 'privacy', value: !!$event.target.value })">
                                <label for="privacy">
                                    <a href="https://www.effe.it/privacy-policy/" target="_blank"><span>{{
                                        $t('step3.privacy.part1') }}</span>
                                    </a>
                                </label>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="wrapper-msg"
                    v-bind:class="{ error: !ticketIsCreatedSuccessfully, success: ticketIsCreatedSuccessfully }"
                    v-if="current_step == 2">
                    <div class="vline"></div>
                    <h2 class="final-msg">
                        {{ this.ticketIsCreatedSuccessfully ? $t('final_msg_success_garanzia') : $t('final_msg_error')
                        }}
                    </h2>
                    <!-- <p class="text-center mt-4 closing_summer" v-html="$t('closing_summer')"></p> -->
                    <button v-if="!ticketIsCreatedSuccessfully" class="icon-back" @click="this.current_step = 1">
                        <img v-bind:src="iconBackBtn">
                    </button>
                    <div class="vline"></div>
                </div>
            </div>

            <div class="wizard-actions" v-if="current_step <= 1">
                <button v-if="current_step == 0 || (current_step == 1 && !fileUploading && !needWaitingToSubmitTicket)"
                    type="button" class="btn btn-outline-primary text-uppercase" @click="submit">{{ current_step != 1 ?
                        $t('wizard.procedi') : $t('wizard.invia_richiesta') }}</button>
                <div v-else class="loader"></div>
            </div>

        </div>
    </div>
</template>


<script>
import { it } from "date-fns/locale";
import ListProductTypes from '../consts/listProducts'
import CustomerForm from "./../components/CustomerForm.vue"
import iconCloseModal from "./../assets/img/close-icon.png"
import iconBackBtn from "./../assets/img/btn_back.png"
import moment from "moment";
import ticketMixin from "@/mixins/ticketMixin";
import { PRIVATO } from '../consts/listProfileTypes'
import TicketController from "./../controllers/TicketController"
import Datepicker from 'vue3-datepicker';
import ListFamilies, { FAMILY_PORTE } from '../consts/listFamilies'
import FileController from "@/controllers/FileController"
import { DEFAULT_PHONE_PREFIX, splitPhoneNumber, withFullPhone } from "@/utils/phone"

function getEccIdFromQuery() {
    return new URLSearchParams(window?.location?.search).get('eccId') || "";
}

function getTicketChannelFromQuery() {
    return new URLSearchParams(window?.location?.search).get('ticket_channel') || "Website";
}

function getCustomerPrefillFromQuery() {
    const query = new URLSearchParams(window?.location?.search);
    const phone = splitPhoneNumber(query.get('telefono') || "");

    return {
        name: query.get('nome') || "",
        surname: query.get('cognome') || "",
        email: query.get('email') || "",
        telephonePrefix: phone.prefix,
        telephone: phone.number
    };
}

function isInverseThemeEnabled() {
    const inverseParam = new URLSearchParams(window?.location?.search).get('inverse');
    return inverseParam === 'true' || inverseParam === '1';
}

function initialErrorState() {
    return {
        data_acquisto_prodotto: false,
        proof_of_purchase: false,
        tipo_di_cliente: false,
        customer_profile_type: false,
        family: false,
        product_with_door: false,
        product: false,
        descrizione_problema: false,
        dc_infunzione: false,
        num_matricola: false,
        file: false,
        privacy: false,
        //customer
        customer_nome: false,
        customer_cognome: false,
        customer_azienda: false,
        customer_email: false,
        customer_tel: false,
        customer_indirizzo: false,
        customer_paese: false,
        customer_cap: false,
        customer_provincia: false
    }
}
export default {
    name: 'RegistraGaranzia',
    mixins: [ticketMixin],
    data() {
        const customerPrefill = getCustomerPrefillFromQuery();

        return {
            ticket: {
                eccId: getEccIdFromQuery(),
                ticket_channel: getTicketChannelFromQuery(),
                tipo_di_cliente: "",
                data_acquisto_prodotto: "",
                proof_of_purchase: "",
                family: "",
                product: "",
                dc_infunzione: "",
                extra_contact: "no",
                num_matricola: "",
                // info matricola
                m_codice_articolo: "",
                m_descrizione: "",
                m_sotto_classe: "",
                m_rivenditore: "",
                m_riferimento_ddt: "",
                m_data_ddt: "",
                m_linea_prodotto: "",
                m_tipologia_prodotto: "",
                descrizione_problema: "",
                contact: {
                    profile_type: "",
                    name: "",
                    surname: "",
                    company: "",
                    email: "",
                    telephonePrefix: DEFAULT_PHONE_PREFIX,
                    telephone: ""
                },
                customer: {
                    profile_type: "",
                    name: customerPrefill.name,
                    surname: customerPrefill.surname,
                    company: "",
                    email: customerPrefill.email,
                    telephonePrefix: customerPrefill.telephonePrefix,
                    telephone: customerPrefill.telephone,
                    address: "",
                    country: "Italia",
                    hs_country_region_code: "IT",
                    cap: "",
                    province: "",
                },
                privacy: false,
                // files
                uploadTokens: [],
                uploadTokensV2: [],
            },
            locale: it,
            errors: initialErrorState(),
            families: ListFamilies,
            product_types: ListProductTypes?.sort((a, b) => String(this.$t(b.label)).toLowerCase() > String(this.$t(a.label)).toLowerCase() ? -1 : 1),
            current_step: 0,
            confirmation_step: 2,
            customer_type_choices: [{
                id: "privato",
                name: this.$t('step2_garanzia.tipo_di_cliente_privato')
            }, {
                id: "pubblico",
                name: this.$t('step2_garanzia.tipo_di_cliente_pubblico')
            }],
            extra_contact_choices: [{
                id: "no",
                name: this.$t('general.no')
            }, {
                id: "si",
                name: this.$t('general.si')
            }],
            iconCloseModal,
            iconBackBtn,
            fileUploading: false,
            proofOfPurchaseFileName: "",
            needWaitingToSubmitTicket: false,
            ticketIsCreatedSuccessfully: false
        }
    },
    mounted: function () {
        this.postMessageIframe()
    },
    methods: {
        getTruncatedFileName(fileName) {
            if (!fileName) return "";
            return fileName.length > 15 ? `${fileName.slice(0, 15)}...` : fileName;
        },
        getRemoveFileIcon() {
            return isInverseThemeEnabled() ? 'images/closeicon_black.png' : 'images/closeicon.png';
        },
        async previewProofOfPurchaseFile(event) {
            const file = event?.target?.files?.[0];
            if (!file) return;

            this.fileUploading = true;

            try {
                const result = await FileController.uploadFile(file);
                this.ticket.proof_of_purchase = result?.data?.data?.fileId || "";
                this.proofOfPurchaseFileName = file.name;
                this.onClearError({ key: 'proof_of_purchase', value: !!this.ticket.proof_of_purchase });
            } catch (error) {
                console.log(error)
                this.errors.proof_of_purchase = true;
            } finally {
                this.fileUploading = false;
                if (event?.target) {
                    event.target.value = "";
                }
            }
        },
        removeProofOfPurchase() {
            this.ticket.proof_of_purchase = "";
            this.proofOfPurchaseFileName = "";
            this.errors.proof_of_purchase = false;
            if (this.$refs.proofOfPurchaseUpload) {
                this.$refs.proofOfPurchaseUpload.value = "";
            }
        },
        async submit() {
            const format_date = "yyyy-MM-DD"
            const validateEmail = (email) => {
                return !!String(email)
                    .toLowerCase()
                    .match(
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    );
            };

            if (this.current_step === 1) {
                let _error = false;
                if (!this.ticket.privacy) { this.errors.privacy = true; _error = true; }
                if (!this.ticket.tipo_di_cliente) { this.errors.tipo_di_cliente = true; _error = true; }
                if (!this.ticket.customer.name) { this.errors.customer_nome = true; _error = true; }
                if (!this.ticket.customer.surname) { this.errors.customer_cognome = true; _error = true; }
                if (!this.ticket.customer.email || !validateEmail(this.ticket.customer.email)) { this.errors.customer_email = true; _error = true; }
                if (!this.ticket.customer.telephone) { this.errors.customer_tel = true; _error = true; }
                if (!this.ticket.customer.address) { this.errors.customer_indirizzo = true; _error = true; }
                if (!this.ticket.customer.country) { this.errors.customer_paese = true; _error = true; }
                if (!this.ticket.customer.cap) { this.errors.customer_cap = true; _error = true; }
                if (!this.ticket.customer.province) { this.errors.customer_provincia = true; _error = true; }

                if (_error) { return; }

                try {
                    this.needWaitingToSubmitTicket = true;
                    const payload = {
                        ...this.ticket,
                        ticket_form: "garanzia",
                        locale: this.getLocale(),
                        customer: {
                            ...withFullPhone(this.ticket.customer),
                            profile_type: PRIVATO,
                            country: this.ticket?.customer?.country
                        },
                        contact: {
                            ...withFullPhone(this.ticket.contact),
                        },
                        descrizione_problema: `Registrazione Garanzia ${this.ticket.product} - Data acquisto ${moment(this.ticket.data_acquisto_prodotto, "DD/MM/yyyy")?.format(format_date) || ""}`,
                        m_rivenditore: this.ticket.m_rivenditore,
                        data_ddt_vendita: this.ticket.data_acquisto_prodotto ? (moment(this.ticket.data_acquisto_prodotto, "DD/MM/yyyy").isValid() ? moment(this.ticket.data_acquisto_prodotto, "DD/MM/yyyy").format(format_date) : "") : "",
                        data_acquisto_prodotto: "", // reset property 
                        data_today: moment().format(format_date),
                        datetime_today: moment().valueOf()
                    }
                    console.log({ payload })
                    const res = await TicketController.newTicket(payload);
                    this.needWaitingToSubmitTicket = false;
                    if (res?.status === 200) {
                        this.ticketIsCreatedSuccessfully = true;
                        if (this.$gtm.enabled()) {
                            window?.dataLayer?.push({
                                event: 'cf7mailInviata',
                                cf7FormId: 'registra_garanzia',
                            });
                            console.log(`gtm cf7mailInviata`)
                        }
                    } else {
                        this.ticketIsCreatedSuccessfully = false;
                    }
                } catch (error) {
                    console.log("ERROR", error)
                    this.ticketIsCreatedSuccessfully = false;
                } finally {
                    this.needWaitingToSubmitTicket = false;
                }
            } else if (this.current_step == 0) {
                let _error = false;
                if (!this.ticket.family) { this.errors.family = true; _error = true; }
                if (!this.ticket.product) { this.errors.product = true; _error = true; }
                if (this.ticket.family === FAMILY_PORTE && !this.ticket.product_with_door) { this.errors.product_with_door = true; _error = true; }
                if (!this.ticket.num_matricola) { this.errors.num_matricola = true; _error = true; }
                if (!this.ticket.data_acquisto_prodotto) { this.errors.data_acquisto_prodotto = true; _error = true; }
                if (!this.ticket.proof_of_purchase) { this.errors.proof_of_purchase = true; _error = true; }
                console.log({ _error, ticket: this.ticket })
                if (_error) { return; }
            }
            initialErrorState();
            this.current_step += 1;
            window.scrollTo(0, 0);
            this.postMessageIframe()
        }
    },
    components: { CustomerForm, Datepicker },
}
</script>
